import React, { FC } from 'react';
import WarningIcon from '@material-ui/icons/Warning';
import NotificationImportantIcon from '@material-ui/icons/NotificationImportant';
import styles from './styles.module.css';

interface ConcurrentPresenceOverlayProps {
  isConcurrent: boolean;
  presence: string;
  isMinimized: boolean;
  onAcknowledge: () => void;
  onReopen: () => void;
  isImpersonating: boolean;
}

export const ConcurrentPresenceOverlay: FC<ConcurrentPresenceOverlayProps> = ({
  isConcurrent,
  presence,
  isMinimized,
  onAcknowledge,
  onReopen,
  isImpersonating,
}) => {
  if (!isConcurrent) {
    return null;
  }

  if (isMinimized) {
    return (
      <div className={styles.minimizedPill} onClick={onReopen}>
        <NotificationImportantIcon fontSize="small" />
        <span>Phát hiện phiên đăng nhập đồng thời</span>
      </div>
    );
  }

  const isImpersonatorView = presence === 'owner-active' || isImpersonating;
  const warningMessage = isImpersonatorView
    ? 'Chủ tài khoản chi nhánh đang online và tương tác đồng thời. Vui lòng cẩn trọng khi thực hiện đơn hàng hoặc chỉnh sửa giỏ hàng để tránh xung đột dữ liệu.'
    : 'Cửa hàng chính đang đồng thời đăng nhập và thao tác trên tài khoản của bạn. Vui lòng lưu ý các thay đổi thông tin hoặc giỏ hàng có thể bị ảnh hưởng.';

  return (
    <div className={styles.overlayBackdrop}>
      <div className={styles.modalCard}>
        <div className={styles.iconHeader}>
          <WarningIcon className={styles.warningIcon} />
        </div>
        <div className={styles.warningTitle}>Phát Hiện Đăng Nhập Đồng Thời</div>
        <div className={styles.warningBody}>{warningMessage}</div>
        <button type="button" className={styles.acknowledgeBtn} onClick={onAcknowledge}>
          Đã hiểu & Tiếp tục
        </button>
      </div>
    </div>
  );
};

export default ConcurrentPresenceOverlay;
